<div
  (mousedown)="this.openModalIfDelivery($event)"
  (click)="this.openModalIfDelivery($event)"
  (focusin)="ensureAutocomplete()"
>
  <app-input-text-atom
    [label]="'parameters.location-placeholder' | translate"
    [iconRight]="'icon-position'"
    [value]="(filterAddress$ | async) ?? ''"
    [cross]="true"
    [fieldBackgroundColor]="fieldBackgroundColor"
    [fieldTextColor]="fieldTextColor"
    [fieldPlaceholderColor]="fieldPlaceholderColor"
    [fieldIconColor]="fieldIconColor"
    (iconClick)="geolocalizeUser()"
    (valueChange)="onValueChange()"
  ></app-input-text-atom>
</div>
@if (geolocalizeError?.length) {
  <div class="pt-2 text-error-700 font-base text-sm">
    {{ geolocalizeError }}
  </div>
}
